/* eslint-disable spaced-comment */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable no-multi-assign */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import debounce from "lodash/debounce";
import { Row, Col, Button, Modal, Table, Card } from "react-bootstrap";
import moment from "moment";

// import styled from "styled-components";
import Text from "../../components/Text";
// import Aux from "../../hoc/_Aux/Aux";
import mapdotService from "../../services/mapdotService";
import { deobfuscateMapdots } from "../../utils/deobfuscate";
import siteAnalyticsService from "../../services/siteAnalyticsService";
import cityService from "../../services/cityService";
import postService from "../../services/postService";
import clientIpService from "../../services/clientIpService";
import MapVenuList from "./components/MapVenuList";
import BailoMap from "./components/BailoMap";
import FilterMainBar from "./components/FilterMainBar";

import Loading from "../../components/Loading"; // inside .js file

// import Pagination from "../admin/components/Pagination";

const { daysOfTheWeek } = require("../../helpers/arrays");

class MainVenues extends Component {
  state = {
    searchWidth: this.props.windowWidth < 992 ? 90 : 0,
    searchString: this.props.windowWidth < 992 ? "90px" : "",
    isOpen: this.props.windowWidth < 992,
    searchBy: "venue",
    filterString: "",
    dayOfWeek: "",
    mapdotsTodaySearchBy: [],
    citiesTodaySearchBy: [],
    currentMapdots: [],
    clickedCityId: "",
    centerLatitude: 45.469149,
    centerLongitude: 9.181158,
    zoomMap: 7,
    visibilityForm: false,
    visibilityFormName: false,
    loading: true,
    isBasic: false,
    isVertically: false,
    isTooltip: false,
    isGrid: false,
    isScrolling: false,
    isLarge: false,
    isModalName: false,
    filterStringName: "",
    mapdotsPerPage: 20,
    currentPage: 1,
    totalMapdots: undefined,
    filteredDate: undefined,
    radioItems: {},
    ipCountryName: "",
    ipCity: "",
    ipCountryLat: "",
    ipCountryLong: "",
    isButtonActive: true,
    venueView: "map",
    isCountryModal: false,
    countryFilterString: "",
    locationSuggestions: [],
    preSearchCenter: null,
  };

  async componentDidMount() {
    const { searchBy } = this.state;
    const { dictionary } = this.props.lang;
    this.debouncedHandleFilterChange = debounce(this.loadAndSetMapdots, 300); // para el buscado, que el tipeo sea un poco mas lento

    try {
      const momentDate = moment();
      const filteredDay = momentDate.format("dddd").toLowerCase();
      const filteredDate = momentDate.format("YYYY-MM-DD");

      const {
        city: ipCity,
        country_name: ipCountryName,
        latitude: ipCountryLat,
        longitude: ipCountryLong,
      } = await this.getGeoInfoFromIp();

      // REVIEW: descomentar para TESTING. Simula que el ip es de un país diferente.
      // const ipCountryName = "Argent";
      // const ipCity = "Córdoba";
      // const ipCountryLat = 45.469149;
      // const ipCountryLong = 11.44;

      //* Trae todos los Mapdots de un país, filtrado por el día de hoy.
      const { mapdots: currentMapdots, meta } = await this.loadMapdots(
        filteredDay,
        searchBy,
        filteredDate,
        ipCountryName,
      );

      //* Ciudad a mostrar: preferir la ciudad del usuario (ipapi.co), sino del backend
      const displayCity = ipCity || (meta && meta.detectedCity) || "";

      //* País a mostrar: preferir ipapi.co, sino el detectado por el backend
      const displayCountry =
        ipCountryName || (meta && meta.detectedCountry) || "";

      //* Centrar: preferir ipapi.co, sino las coordenadas de la ciudad detectada por el backend
      const centerLat =
        ipCountryLat && ipCountryLat !== 0
          ? ipCountryLat
          : (meta && meta.detectedCityLat) || null;
      const centerLng =
        ipCountryLong && ipCountryLong !== 0
          ? ipCountryLong
          : (meta && meta.detectedCityLng) || null;

      //* Ciudades para el dropdown: preferir meta.citiesInCountry, sino extraer de los mapdots directamente
      let filteredCities;
      if (meta && meta.citiesInCountry && meta.citiesInCountry.length > 0) {
        filteredCities = meta.citiesInCountry.map((c) => ({
          cityName: c.name,
          lat: c.lat,
          lng: c.lng,
          _id: c.name,
        }));
      } else {
        filteredCities = this.extractCitiesFromMapdots(currentMapdots);
      }

      if (displayCity) {
        this.showToast(dictionary.city, displayCity);
      }

      this.setState({
        dayOfWeek: filteredDay,
        filteredDate,
        ipCity: displayCity,
        centerLatitude: centerLat,
        centerLongitude: centerLng,
        zoomMap: displayCity ? 9 : 5,
        ipCountryName: displayCountry,
        currentMapdots,
        citiesTodaySearchBy: filteredCities,
        mapdotsTodaySearchBy: currentMapdots,
        loading: false,
      });
    } catch (error) {
      console.log(error);
      this.showToast(
        dictionary.errorLoadingData || "Error loading data",
        "",
        "error",
      );
      this.setState({ loading: false });
    }
  }

  // NOTE: ========= Seccion de Helpers =========

  // Función auxiliar para mostrar los toasts
  showToast(title, message, type = "info") {
    if (type === "info") toast.info(`${title}: ${message}`);
    else if (type === "error") toast.error(`${title}: ${message}`);
  }

  // Pone en mayuscula la primera letra del Venue dropdown
  capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  setView = (venueView) => {
    this.setState({ venueView });
  };

  async getGeoInfoFromIp() {
    try {
      return await clientIpService.getIpLocation();
    } catch (error) {
      return error;
    }
  }

  // encapsula logia del handleChangeFilter, para busquedas
  loadAndSetMapdots = async (filterStringName) => {
    const updatedCurrentMadots =
      await this.loadCurrentMapdots(filterStringName);

    this.setState({
      visibilityFormName: true,
      filterStringName,
      currentMapdots: updatedCurrentMadots,
    });
  };

  // NOTE: ======== Seccion de llamadas a Service ========

  async loadMapdots(day, category, filteredDate, ipCountryName) {
    const result = await mapdotService.searchMapdots(
      day,
      category,
      filteredDate,
      ipCountryName,
    );
    if (Array.isArray(result))
      return { mapdots: deobfuscateMapdots(result), meta: null };
    return {
      mapdots: deobfuscateMapdots(result.mapdots || []),
      meta: result.meta || null,
    };
  }

  async loadMapdotsNoDay(category) {
    try {
      return await mapdotService.searchMapdotsNoDay(category);
    } catch (error) {
      return error;
    }
  }

  async loadCurrentMapdots(filterStringName) {
    try {
      return await mapdotService.getPublicBailoDots(filterStringName);
    } catch (error) {
      return error;
    }
  }

  // para cargar citiesTodaySearchBy cuando se abre el modal ante del componentDidMount
  handleOpenCityModal = () => {
    this.setState({
      isLarge: true,
      visibilityForm: false,
      filterString: "",
    });
  };

  // NOTE: ======== Seccion de Handlers para MODALS ========

  async getDayNameFromDate(date) {
    try {
      const d = new Date(date);
      let dayName;
      if (d.getDay() === 0) {
        dayName = daysOfTheWeek[6].day;
      } else if (d.getDay() === 1) {
        dayName = daysOfTheWeek[0].day;
      } else if (d.getDay() === 2) {
        dayName = daysOfTheWeek[1].day;
      } else if (d.getDay() === 3) {
        dayName = daysOfTheWeek[2].day;
      } else if (d.getDay() === 4) {
        dayName = daysOfTheWeek[3].day;
      } else if (d.getDay() === 5) {
        dayName = daysOfTheWeek[4].day;
      } else {
        dayName = daysOfTheWeek[5].day;
      }

      return dayName;
    } catch (error) {
      return error;
    }
  }

  async getDateFromDayName(dayName) {
    try {
      const shortDay = dayName.slice(0, 3);
      let date;

      const now = moment();
      const nowPlus1 = moment().add(1, "days");
      const nowPlus2 = moment().add(2, "days");
      const nowPlus3 = moment().add(3, "days");
      const nowPlus4 = moment().add(4, "days");
      const nowPlus5 = moment().add(5, "days");
      const nowPlus6 = moment().add(6, "days");

      if (now._d.toString().slice(0, 3).toLowerCase() === shortDay) {
        date = now.format("YYYY-MM-DD");
      } else if (
        nowPlus1._d.toString().slice(0, 3).toLowerCase() === shortDay
      ) {
        date = nowPlus1.format("YYYY-MM-DD");
      } else if (
        nowPlus2._d.toString().slice(0, 3).toLowerCase() === shortDay
      ) {
        date = nowPlus2.format("YYYY-MM-DD");
      } else if (
        nowPlus3._d.toString().slice(0, 3).toLowerCase() === shortDay
      ) {
        date = nowPlus3.format("YYYY-MM-DD");
      } else if (
        nowPlus4._d.toString().slice(0, 3).toLowerCase() === shortDay
      ) {
        date = nowPlus4.format("YYYY-MM-DD");
      } else if (
        nowPlus5._d.toString().slice(0, 3).toLowerCase() === shortDay
      ) {
        date = nowPlus5.format("YYYY-MM-DD");
      } else {
        date = nowPlus6.format("YYYY-MM-DD");
      }

      return date;
    } catch (error) {
      return error;
    }
  }

  handleChangeSearchBy = async (event) => {
    const { dayOfWeek, filteredDate, ipCountryName } = this.state;

    let updatedMadots;
    const searchBy = event;

    siteAnalyticsService.track({
      eventType: "venue_dropdown_click",
      category: searchBy,
    });

    this.setState({
      loading: true,
    });

    if (
      searchBy === "venue" ||
      searchBy === "practica" ||
      searchBy === "class"
    ) {
      const { mapdots } = await this.loadMapdots(
        dayOfWeek,
        searchBy,
        filteredDate,
        ipCountryName,
      );
      updatedMadots = mapdots;
    } else {
      updatedMadots = await this.loadMapdotsNoDay(searchBy);

      const momentDate = moment();
      const filteredDay = await momentDate.format("dddd").toLowerCase();
      const getFilteredDate = await momentDate.format("YYYY-MM-DD");

      this.setState({
        dayOfWeek: filteredDay,
        filteredDate: getFilteredDate,
      });
    }

    const updatedCities = this.extractCitiesFromMapdots(updatedMadots || []);

    // Center on user's city in the new results, or keep current position
    const {
      ipCity: currentIpCity,
      centerLatitude: curLat,
      centerLongitude: curLng,
    } = this.state;
    const foundCity = updatedCities.find(
      (c) =>
        c.cityName &&
        currentIpCity &&
        c.cityName.toLowerCase() === currentIpCity.toLowerCase(),
    );
    const newCenterLat = (foundCity && foundCity.lat) || curLat;
    const newCenterLng = (foundCity && foundCity.lng) || curLng;

    this.setState({
      searchBy,
      currentMapdots: updatedMadots,
      mapdotsTodaySearchBy: updatedMadots,
      citiesTodaySearchBy: updatedCities,
      centerLatitude: newCenterLat,
      centerLongitude: newCenterLng,
      zoomMap: 12,
      loading: false,
    });
  };

  handleChangeDate = async (event) => {
    const { searchBy, ipCountryName } = this.state;
    const momentDate = moment();
    const filteredDate = await momentDate.format("YYYY-MM-DD");

    let updatedMadots;
    const dayOfWeek = event;

    this.setState({
      loading: true,
    });

    if (
      searchBy === "venue" ||
      searchBy === "practica" ||
      searchBy === "class"
    ) {
      const { mapdots } = await this.loadMapdots(
        dayOfWeek,
        searchBy,
        filteredDate,
        ipCountryName,
      );
      updatedMadots = mapdots;
    } else {
      updatedMadots = await this.loadMapdotsNoDay(searchBy);
    }

    const updatedCities = this.extractCitiesFromMapdots(updatedMadots || []);

    // Center on user's city in the new results, or keep current position
    const {
      ipCity: currentIpCity,
      centerLatitude: curLat,
      centerLongitude: curLng,
    } = this.state;
    const foundCity = updatedCities.find(
      (c) =>
        c.cityName &&
        currentIpCity &&
        c.cityName.toLowerCase() === currentIpCity.toLowerCase(),
    );
    const newCenterLat = (foundCity && foundCity.lat) || curLat;
    const newCenterLng = (foundCity && foundCity.lng) || curLng;

    this.setState({
      filteredDate,
      dayOfWeek,
      currentMapdots: updatedMadots,
      mapdotsTodaySearchBy: updatedMadots,
      citiesTodaySearchBy: updatedCities,
      centerLatitude: newCenterLat,
      centerLongitude: newCenterLng,
      zoomMap: 12,
      loading: false,
    });
  };

  // filtro de lupa
  handleChangeFilter = (event) => {
    const { value } = event.target;

    this.setState({ filterStringName: value });

    if (value.length >= 3) {
      this.debouncedHandleFilterChange(value);
    } else {
      this.setState((prev) => ({
        visibilityFormName: false,
        ...(prev.preSearchCenter
          ? {
              centerLatitude: prev.preSearchCenter.lat,
              centerLongitude: prev.preSearchCenter.lng,
              zoomMap: prev.preSearchCenter.zoom,
            }
          : {}),
      }));
    }
  };

  // Builds a city list directly from mapdots' city string + coordinates.
  // Does NOT require cityObject — works even when cityObject is null/missing.
  extractCitiesFromMapdots(mapdots) {
    const seen = new Set();
    const cities = [];
    mapdots.forEach((m) => {
      if (m.city && !seen.has(m.city)) {
        seen.add(m.city);
        const lat =
          (m.coordinatesLatLong &&
            (m.coordinatesLatLong.lat || m.coordinatesLatLong.Latitude)) ||
          null;
        const lng =
          (m.coordinatesLatLong &&
            (m.coordinatesLatLong.lng || m.coordinatesLatLong.Longitude)) ||
          null;
        cities.push({ cityName: m.city, lat, lng, _id: m.city });
      }
    });
    return cities;
  }

  // devuelve los datos completos de todas las ciudades únicas
  async loadCities(getMapdots) {
    try {
      const filteredCityIds = getMapdots
        .filter((oneMapdot) => oneMapdot.cityObject)
        .map((oneMapdot) => oneMapdot.cityObject.toString())
        .reduce((accumulator, currentValue) => {
          if (accumulator.indexOf(currentValue) === -1) {
            accumulator.push(currentValue);
          }
          return accumulator;
        }, []);

      if (filteredCityIds.length === 0) return [];
      return await cityService.searchCities(filteredCityIds);
    } catch (error) {
      return [];
    }
  }

  // Filtro por Ciudades - cuando se escribe
  handleChangeCities = (event) => {
    const input = event.target.value;

    this.setState({
      filterString: input,
      visibilityForm: true,
    });
  };

  // log de slack para cuidades
  async handleClickCity(city) {
    const { cityName, lat, lng } = city;
    const { currentMapdots } = this.state;

    siteAnalyticsService.track({
      eventType: "city_click",
      venueName: cityName,
    });

    // Post para log en SLACK
    try {
      await postService.sendCity(cityName);
    } catch (error) {
      console.log("Error enviando a Slack:", error);
    }

    // Use coordinates from meta format (lat/lng) or fall back to searching currentMapdots
    if (lat && lng) {
      this.setState({
        zoomMap: 13,
        centerLatitude: lat,
        centerLongitude: lng,
        ipCity: cityName,
        isLarge: false,
        visibilityForm: false,
      });
    } else {
      const selectedCity = currentMapdots.find((c) => c.city === cityName);
      if (selectedCity && selectedCity.coordinatesLatLong) {
        this.setState({
          zoomMap: 13,
          centerLatitude:
            selectedCity.coordinatesLatLong.Latitude ||
            selectedCity.coordinatesLatLong.lat,
          centerLongitude:
            selectedCity.coordinatesLatLong.Longitude ||
            selectedCity.coordinatesLatLong.lng,
          ipCity: cityName,
          isLarge: false,
          visibilityForm: false,
        });
      } else {
        console.warn(`Ciudad "${cityName}" no encontrada.`);
      }
    }
  }

  //   this.setState({
  //     zoomMap: 13,
  //     centerLatitude: city.coordinatesLatLongCity.Latitude,
  //     centerLongitude: city.coordinatesLatLongCity.Longitude,
  //     currentMapdots: city,
  //     isLarge: false,
  //     visibilityForm: false,
  //   });
  // }

  handleSelectLocation = async (location) => {
    const { searchBy, dayOfWeek, filteredDate } = this.state;
    this.setState({
      loading: true,
      isCountryModal: false,
      countryFilterString: "",
      locationSuggestions: [],
    });
    const { mapdots: currentMapdots, meta } = await this.loadMapdots(
      dayOfWeek,
      searchBy,
      filteredDate,
      location.country,
    );
    let filteredCities;
    if (meta && meta.citiesInCountry && meta.citiesInCountry.length > 0) {
      filteredCities = meta.citiesInCountry.map((c) => ({
        cityName: c.name,
        lat: c.lat,
        lng: c.lng,
        _id: c.name,
      }));
    } else {
      filteredCities = this.extractCitiesFromMapdots(currentMapdots);
    }
    this.setState({
      ipCity: location.city,
      ipCountryName: location.country,
      centerLatitude: location.lat || this.state.centerLatitude,
      centerLongitude: location.lng || this.state.centerLongitude,
      zoomMap: location.lat ? 12 : 5,
      currentMapdots,
      mapdotsTodaySearchBy: currentMapdots,
      citiesTodaySearchBy: filteredCities,
      loading: false,
    });
  };

  async handleClickMapdot(mapdot) {
    const searchBy = mapdot.categoryIdName;
    let dayOfWeek = "";
    let filteredDate = "";
    let updatedMadots;

    this.setState({
      loading: true,
    });

    if (
      searchBy === "venue" ||
      searchBy === "practica" ||
      searchBy === "class"
    ) {
      dayOfWeek = mapdot.day;

      if (mapdot.dateOnce !== "") {
        filteredDate = mapdot.dateOnce;
      } else if (
        mapdot.dateStart !== "" &&
        mapdot.dateEnd !== "" &&
        searchBy === "class"
      ) {
        filteredDate = mapdot.dateStart;
      } else {
        filteredDate = await this.getDateFromDayName(dayOfWeek);
      }

      const { mapdots } = await this.loadMapdots(
        dayOfWeek,
        searchBy,
        filteredDate,
        this.state.ipCountryName,
      );
      updatedMadots = mapdots;
    } else {
      const momentDate = moment();
      dayOfWeek = await momentDate.format("dddd").toLowerCase();
      filteredDate = await momentDate.format("YYYY-MM-DD");

      updatedMadots = await this.loadMapdotsNoDay(searchBy);
    }

    const updatedCities = this.extractCitiesFromMapdots(updatedMadots || []);
    const bailoDotTitle =
      mapdot.title !== "" ? mapdot.title : mapdot.publicName;

    const lat =
      mapdot.coordinatesLatLong.lat || mapdot.coordinatesLatLong.Latitude;
    const lng =
      mapdot.coordinatesLatLong.lng || mapdot.coordinatesLatLong.Longitude;

    try {
      await postService.sendBailoDot(bailoDotTitle).catch((error) => {
        console.log(error);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    this.setState({
      filteredDate,
      searchBy,
      dayOfWeek,
      currentMapdots: updatedMadots,
      mapdotsTodaySearchBy: updatedMadots,
      citiesTodaySearchBy: updatedCities,
      centerLatitude: lat,
      centerLongitude: lng,
      zoomMap: 15,
      isModalName: false,
      visibilityFormName: false,
      loading: false,
      filterStringName: "",
      preSearchCenter: null,
    });
  }

  render() {
    const {
      mapdotsTodaySearchBy,
      loading,
      searchBy,
      filterString,
      citiesTodaySearchBy,
      // eslint-disable-next-line no-unused-vars
      visibilityForm,
      // eslint-disable-next-line no-unused-vars
      centerLatitude,
      centerLongitude,
      zoomMap,
      currentMapdots, // TODO: analizar este punto. Por que hay tantos mapdots cargados?
      ipCity,
      ipCountryName,
      // isButtonActive,
      dayOfWeek,

      venueView,
    } = this.state;

    const { dictionary } = this.props.lang;

    return (
      <React.Fragment>
        {/* {loading && <Loading />}
        {!loading && ( */}

        {/* CONTENIDO PRINCIPAL: Filtro + Mapa/Lista (izq) + Card lateral (der) */}
        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <FilterMainBar
              searchBy={searchBy}
              dayOfWeek={dayOfWeek}
              ipCity={ipCity}
              ipCountryName={ipCountryName}
              venueView={venueView}
              dictionary={dictionary}
              handleChangeSearchBy={this.handleChangeSearchBy}
              handleChangeDate={this.handleChangeDate}
              onOpenSearchModal={() =>
                this.setState((prev) => ({
                  isModalName: true,
                  preSearchCenter: {
                    lat: prev.centerLatitude,
                    lng: prev.centerLongitude,
                    zoom: prev.zoomMap,
                  },
                }))
              }
              onToggleView={() =>
                this.setView(venueView === "map" ? "list" : "map")
              }
              capitalize={this.capitalize}
              citiesTodaySearchBy={citiesTodaySearchBy}
              handleClickCity={(city) => this.handleClickCity(city)}
              onClickCountry={() => this.setState({ isCountryModal: true })}
            />

            <div className="mt-3 mt-md-4">
              {loading && <Loading />}

              {!loading &&
                (venueView === "list" ? (
                  <Card className="mapdot-container">
                    <MapVenuList
                      mapdots={mapdotsTodaySearchBy}
                      currentCity={ipCity}
                    />
                  </Card>
                ) : (
                  <Card className="mapdot-container">
                    <Card.Body className="p-0">
                      <BailoMap
                        mapdotsTodaySearchBy={mapdotsTodaySearchBy}
                        centerLatitude={centerLatitude}
                        centerLongitude={centerLongitude}
                        zoomMap={zoomMap}
                      />
                    </Card.Body>
                  </Card>
                ))}
            </div>
          </Col>

        </Row>

        {/* -- NOTE: Seccion de Modals -- */}
        {/* Modal cambio de país */}
        <Modal
          size="sm"
          show={this.state.isCountryModal}
          onHide={() =>
            this.setState({ isCountryModal: false, countryFilterString: "" })
          }
        >
          <Modal.Header>
            <Modal.Title style={{ fontFamily: "Montserrat", fontSize: "1rem" }}>
              <i className="feather icon-globe" />{" "}
              {dictionary.selectCountry || "Select country"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            <input
              className="form-control"
              type="search"
              placeholder={dictionary.filterBy || "Country or city..."}
              value={this.state.countryFilterString}
              onChange={async (e) => {
                const val = e.target.value;
                this.setState({ countryFilterString: val });
                if (val.length >= 3) {
                  const suggestions = await mapdotService.searchLocations(val);
                  this.setState({ locationSuggestions: suggestions });
                } else {
                  this.setState({ locationSuggestions: [] });
                }
              }}
              autoFocus
              autoComplete="off"
            />
            {this.state.locationSuggestions.length > 0 && (
              <ul
                className="list-group mt-2"
                style={{ maxHeight: 220, overflowY: "auto", cursor: "pointer" }}
              >
                {this.state.locationSuggestions.map((loc, i) => (
                  <li
                    key={i}
                    className="list-group-item list-group-item-action py-2"
                    onClick={() => this.handleSelectLocation(loc)}
                  >
                    {loc.country}, {loc.city}
                  </li>
                ))}
              </ul>
            )}
            {this.state.countryFilterString.length > 0 &&
              this.state.countryFilterString.length < 3 && (
                <small className="text-muted mt-1 d-block">
                  {dictionary.typeMoreChars || "Type at least 3 characters..."}
                </small>
              )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                this.setState({
                  isCountryModal: false,
                  countryFilterString: "",
                  locationSuggestions: [],
                })
              }
            >
              {dictionary.closeButton}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal filtro por ciudad */}
        <Modal
          size="lg"
          show={this.state.isLarge}
          onHide={() =>
            this.setState({ isLarge: false, visibilityForm: false })
          }
        >
          <Modal.Body
            className="p-3"
            style={{
              maxHeight: "calc(100vh - 210px)",
              overflowY: "auto",
            }}
          >
            <form
              autoComplete="off"
              onKeyDown={(event) => {
                // Prevenir la acción por defecto cuando se presiona Enter
                if (event.key === "Enter") {
                  event.preventDefault();
                }
              }}
            >
              <input
                className="form-control"
                type="search"
                id="clickedCityId"
                name="clickedCityId"
                placeholder={dictionary.filterBy}
                onChange={this.handleChangeCities}
                autoComplete="off"
              />
              {filterString.length >= 3 && visibilityForm && (
                <ul className="ul-text">
                  {citiesTodaySearchBy.length > 0 &&
                  citiesTodaySearchBy.filter((city) =>
                    city.cityName
                      .toLowerCase()
                      .startsWith(filterString.toLowerCase()),
                  ).length > 0 ? (
                    citiesTodaySearchBy
                      .filter((city) =>
                        city.cityName
                          .toLowerCase()
                          .startsWith(filterString.toLowerCase()),
                      )
                      .map((city) => (
                        <li
                          className="li-text"
                          key={city._id}
                          value={city._id}
                          onClick={() => this.handleClickCity(city)}
                        >
                          <a href="#">{city.cityName}</a>
                        </li>
                      ))
                  ) : (
                    <div style={{ fontFamily: `Montserrat` }}>
                      <Text tid="noResultsfound" />
                    </div>
                  )}
                </ul>
              )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => this.setState({ isLarge: false })}
            >
              {dictionary.closeButton}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de busqueda (lupa) */}
        <Modal
          size="lg"
          show={this.state.isModalName}
          onHide={() =>
            this.setState((prev) => ({
              isModalName: false,
              visibilityFormName: false,
              filterStringName: "",
              ...(prev.preSearchCenter
                ? {
                    centerLatitude: prev.preSearchCenter.lat,
                    centerLongitude: prev.preSearchCenter.lng,
                    zoomMap: prev.preSearchCenter.zoom,
                  }
                : {}),
              preSearchCenter: null,
            }))
          }
        >
          <Modal.Body
            className="p-3"
            style={{
              maxHeight: "calc(100vh - 210px)",
              overflowY: "auto",
            }}
          >
            <form
              autoComplete="off"
              onKeyDown={(event) => {
                // Prevenir la acción por defecto cuando se presiona Enter
                if (event.key === "Enter") {
                  event.preventDefault();
                }
              }}
            >
              <input
                className="form-control"
                type="search"
                id="clickedMilongaId"
                name="clickedMilongaId"
                placeholder={dictionary.filterByMilongaName}
                onChange={this.handleChangeFilter}
                value={this.state.filterStringName}
                autoComplete="off"
              />
              {this.state.filterStringName.length >= 3 &&
                this.state.visibilityFormName && (
                  <div>
                    <Table responsive hover>
                      <tbody>
                        {currentMapdots.filtered.length !== 2 ? (
                          currentMapdots.filtered
                            .slice(0)
                            .reverse()
                            .map((mapdot) => (
                              <tr
                                className="li-text"
                                key={mapdot._id}
                                value={mapdot._id}
                                onClick={() => this.handleClickMapdot(mapdot)}
                                style={{ cursor: "pointer" }}
                              >
                                <td>
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#007bff",
                                    }}
                                  >
                                    {mapdot.title !== ""
                                      ? mapdot.title
                                      : mapdot.publicName}
                                  </span>
                                </td>
                                <td>
                                  <i
                                    className="fa fa-map-marker me-1"
                                    style={{
                                      color: "#4e6ac5",
                                    }}
                                  ></i>
                                  {mapdot.city}
                                  <br />
                                  <i
                                    className="fas fa-music me-1"
                                    style={{
                                      color: "#4e6ac5",
                                    }}
                                  ></i>
                                  {dictionary[mapdot.categoryIdName]}
                                  <br />
                                  {[
                                    "school",
                                    "teacher",
                                    "radio",
                                    "musician",
                                  ].includes(mapdot.categoryIdName) ? null : (
                                    <>
                                      <i
                                        className="fas fa-calendar me-1"
                                        style={{
                                          color: "#4e6ac5",
                                        }}
                                      ></i>
                                      {dictionary[mapdot.day]}
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td style={{ fontFamily: `Montserrat` }}>
                              <Text tid="noResultsfound" />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() =>
                this.setState((prev) => ({
                  isModalName: false,
                  filterStringName: "",
                  visibilityFormName: false,
                  ...(prev.preSearchCenter
                    ? {
                        centerLatitude: prev.preSearchCenter.lat,
                        centerLongitude: prev.preSearchCenter.lng,
                        zoomMap: prev.preSearchCenter.zoom,
                      }
                    : {}),
                  preSearchCenter: null,
                }))
              }
            >
              {dictionary.closeButton}
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

MainVenues.propTypes = {
  auth: PropTypes.object.isRequired,
  lang: PropTypes.object.isRequired,
  layout: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
  layout: state.layout,
});

export default connect(mapStateToProps)(MainVenues);
